// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Environment-module__chartShadow___5hLDx {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);
    /* height: fit-content; */
    padding: 1rem;
    top: 0;
    left: 0;
    display: 'block';
}

.Environment-module__envGraph___TKZOH {
    aspect-ratio: 5/2.7;
    top: 0;
    left: 0;
    display: 'block';
}

.Environment-module__envGraphNoDays___LmsyR {
    aspect-ratio: 7/1.5;
    top: 0;
    left: 0;
    display: 'block';
}


@media (min-aspect-ratio: 2) {
    .Environment-module__chartShadow___5hLDx {
        padding: 0.5rem;
    }

    .Environment-module__envGraph___TKZOH {
        aspect-ratio: 5/2;
    }

    .Environment-module__envGraphNoDays___LmsyR {
        aspect-ratio: 7/1;
    }
}

/* Handle very high zoom levels (like 175%) or narrow screens */
@media (max-width: 1600px) and (min-width: 700px) {
    .Environment-module__envGraph___TKZOH {
        aspect-ratio: 5/2.4;
    }

    .Environment-module__envGraphWithFootNote___mDjyH {
        aspect-ratio: 5/2.2;
    }

}`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/Environment/Environment.module.css"],"names":[],"mappings":"AAAA;IACI,sGAAsG;IACtG,yBAAyB;IACzB,aAAa;IACb,MAAM;IACN,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,MAAM;IACN,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,MAAM;IACN,OAAO;IACP,gBAAgB;AACpB;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,+DAA+D;AAC/D;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;AAEJ","sourcesContent":[".chartShadow {\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);\n    /* height: fit-content; */\n    padding: 1rem;\n    top: 0;\n    left: 0;\n    display: 'block';\n}\n\n.envGraph {\n    aspect-ratio: 5/2.7;\n    top: 0;\n    left: 0;\n    display: 'block';\n}\n\n.envGraphNoDays {\n    aspect-ratio: 7/1.5;\n    top: 0;\n    left: 0;\n    display: 'block';\n}\n\n\n@media (min-aspect-ratio: 2) {\n    .chartShadow {\n        padding: 0.5rem;\n    }\n\n    .envGraph {\n        aspect-ratio: 5/2;\n    }\n\n    .envGraphNoDays {\n        aspect-ratio: 7/1;\n    }\n}\n\n/* Handle very high zoom levels (like 175%) or narrow screens */\n@media (max-width: 1600px) and (min-width: 700px) {\n    .envGraph {\n        aspect-ratio: 5/2.4;\n    }\n\n    .envGraphWithFootNote {\n        aspect-ratio: 5/2.2;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartShadow": `Environment-module__chartShadow___5hLDx`,
	"envGraph": `Environment-module__envGraph___TKZOH`,
	"envGraphNoDays": `Environment-module__envGraphNoDays___LmsyR`,
	"envGraphWithFootNote": `Environment-module__envGraphWithFootNote___mDjyH`
};
export default ___CSS_LOADER_EXPORT___;
